// Host identity reported by the `version` intrinsic.  (The MiniScript version
// and build date come from the engine itself.)
export const versionConfig = {
  hostName: "miniscript-tryit",
  hostInfo: "https://github.com/JoeStrout/miniscript-tryit",
  hostVersion: "2.0"
};
